var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntityCreationIconSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1271_71128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6169 13.3427C15.4228 13.3427 14.4548 12.3747 14.4548 11.1806C14.4548 9.98655 15.4228 9.01855 16.6169 9.01855C17.811 9.01855 18.779 9.98655 18.779 11.1806C18.779 12.3747 17.811 13.3427 16.6169 13.3427Z",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4756 16.68C13.7734 16.3652 14.1181 16.0957 14.4989 15.8817C15.1456 15.5185 15.8749 15.3276 16.6167 15.3276C17.3585 15.3276 18.0878 15.5185 18.7345 15.8817C19.0143 16.0389 19.2745 16.226 19.511 16.4391",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.62187 12.6489C8.14217 12.6489 6.94263 11.4494 6.94263 9.96971C6.94263 8.49 8.14217 7.29047 9.62187 7.29047C11.1016 7.29047 12.3011 8.49 12.3011 9.96971C12.3011 11.4494 11.1016 12.6489 9.62187 12.6489Z",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6408 20.3004C14.5072 18.7001 14.1084 17.6478 13.8898 17.2773C13.4243 16.486 12.7701 15.8318 11.9901 15.378C11.2101 14.9241 10.3305 14.6857 9.43585 14.6857C8.5412 14.6857 7.6616 14.9241 6.88159 15.378C6.25876 15.7404 5.71615 16.2304 5.28578 16.8162L5.01294 17.2245",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 20.7286C7.1794 20.7286 3.27148 16.8207 3.27148 12C3.27148 7.17934 7.1794 3.27142 12.0001 3.27142C16.8208 3.27142 20.7286 7.17934 20.7286 12C20.7286 16.8207 16.8208 20.7286 12.0001 20.7286Z",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1271_71128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntityCreationIconSelected);
export default __webpack_public_path__ + "static/media/EntityCreationIconSelected.94baba8a3bb8ce51aa94379b2647e452.svg";
export { ForwardRef as ReactComponent };